import React from 'react';
import {Line} from "react-chartjs-2";
import {Row, Col, Typography} from 'antd';
import './Chart.css';

const {Title} = Typography;

const CryptoLineChart = ({currentPrice, coinName, cryptoHistory}) => {
    const coinPrice = [];
    const coinTimestamp = [];

    cryptoHistory?.data?.history?.forEach((item, index) => {
            coinPrice.push(item.price);
            coinTimestamp.push((new Date(item.timestamp)).toLocaleDateString()); 
    })
     
    const data = {
        labels: coinTimestamp,
        datasets: [
            {
                data: coinPrice,
                label: "Price in USD",
                fill : true,
                backgroundColor: `${cryptoHistory?.data.change > 0 ? "#71d46d48" : "#d1475056"}`,
                borderColor: `${cryptoHistory?.data.change > 0 ? "#30a02cd2" : "#ff424f"}`,
                pointRadius: 1,
            }
        ]
    }

    const options = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    }
                }
            ]
        }
    }

    return (
        <>
         <Row className='chart-header px-2'>
            <Title level={3} className='chart-title'>
                {coinName} Price Chart
            </Title>
            <Col className='price-container'>
                <Title level={5} className='price-change'>
                    {cryptoHistory?.data.change} %
                </Title>
                <Title level={5} className='current-price'>
                    <strong>Current Price: </strong> {currentPrice}
                </Title>
            </Col>
         </Row>   
         {
            coinPrice.length > 0 && coinPrice.length > 0 ? (
                <Line data={data} options={options}/>
            ) : (
                <></>
            ) 
         }
        </>
    )
}

export default CryptoLineChart
